// Real PX7 green-circle logo. Served from /logo.png (2000×2000 source, scaled
// by the browser). Falls back to a text mark if the image fails to load.
export function Logo({ size = 36 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      width={size}
      height={size}
      alt="PX7 Training"
      className="shrink-0 rounded-full"
      draggable={false}
      style={{ width: size, height: size }}
    />
  );
}

export function Wordmark({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Logo size={32} />
      <div className="leading-tight">
        <div className="font-display text-[1.05rem] font-bold text-px-text">PX7 Training</div>
        <div className="hidden text-[10px] uppercase tracking-[0.18em] text-px-text-muted sm:block">
          Science · Performance
        </div>
      </div>
    </div>
  );
}
